export function extractNumber(str: string) {
  const number = parseInt(str.replace(/,/g, ""), 10);

  return isNaN(number) ? 0 : number;
}
